import React from 'react';
import { useBuild } from '../../contexts/BuildContext';
import QueryModes from '../../search/QueryModes';

// Shared by all chain-specific notification aliases:
//   hyperliquid-notifications, polymarket-notifications, dex-notifications,
//   kalshi-notifications. Each backs an `alpha-notifications-<chain>` index
//   whose mapping is flat (not nested): signal_id, signal_type,
//   notification_type, priority, chain, headline, token_symbol, token_address,
//   token_price_usd, token_price_change_pct, trader_count, total_usd_inflow,
//   highest_rank, timestamp, created_at. The original nested DSL payload is
//   preserved as the text field `payload_json`.
const SORT_OPTIONS = [
  { id: 'timestamp', label: 'timestamp' },
  { id: 'created_at', label: 'created_at' },
  { id: 'total_usd_inflow', label: 'total_usd_inflow' },
  { id: 'trader_count', label: 'trader_count' },
  { id: 'highest_rank', label: 'highest_rank' },
  { id: 'token_price_change_pct', label: 'token_price_change_pct' },
  { id: 'token_price_usd', label: 'token_price_usd' },
  { id: 'null', label: 'None' },
];

const FILTER_TYPE_OPTIONS = [
  { id: 'item_ids', label: 'Signal IDs' },
  { id: 'notification_filters', label: 'Notification Type / Priority / Chain' },
  { id: 'date', label: 'Date Range' },
  { id: 'numeric_filters', label: 'Numeric Filters' },
  { id: 'keywords', label: 'Keywords' },
];

const NotificationsQuery = () => {
  const { selectedIndex } = useBuild();
  return (
    <QueryModes
      source={selectedIndex}
      sortOptions={SORT_OPTIONS}
      strictFilterTypeOptions={FILTER_TYPE_OPTIONS}
      boostFilterTypeOptions={FILTER_TYPE_OPTIONS}
    />
  );
};

export default NotificationsQuery;
